import script from "./BottomTouchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./BottomTouchBar.vue?vue&type=script&setup=true&lang=ts"

import "./BottomTouchBar.vue?vue&type=style&index=0&id=627a8a4e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-627a8a4e"]])

export default __exports__